<template>
  <div class="proj-manager-box page-primary">
    <div v-if="loading">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div class="header-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">人员管理列表</div>
      </div>
    </div>
    <div class="operation-box operate-area">
      <div class="common-button-box btn-group-primary">
        <el-button
          class="primary-btn gr8"
          v-if="isChecked('Project.ManagerManage.Add')"
          type="primary"
          size="small"
          @click="openManagerDialog">
          添加人员
        </el-button>
        <el-button
          class="normal-btn"
          v-if="isChecked('Project.ManagerManage.BatchDelete')"
          size="small"
          @click="batchRemoveManager">
          批量移除
        </el-button>
      </div>
      <div class="filter-box">
        <div class="filter-item-box gr16">
          <div class="label-box gr16 searchLabel">用户名</div>
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              placeholder="请输入用户名称"
              v-model="userName" />
          </div>
        </div>
        <div class="filter-item-box">
          <!-- <div class="label-box">手机号：</div> -->
          <div class="common-input-box">
            <el-input
              class="input-primary"
              size="small"
              placeholder="请输入手机号"
              v-model="phone" />
          </div>
        </div>
        <div class="common-button-box">
          <el-button
            class="primary-btn gl16"
            type="text"
            size="small"
            @click="searchManager">
            查询
          </el-button>
          <el-button
            class="normal-btn"
            type="text"
            size="small"
            @click="resetFilter"
            >重置</el-button
          >
        </div>
      </div>
    </div>
    <div class="manager-list-box">
      <div class="common-table-box">
        <el-table
          v-if="!loading"
          class="publish-table"
          :data="managerList"
          highlight-selection-row
          height="100%"
          @select="selectChange"
          @select-all="selectChange">
          <el-table-column
            type="selection"
            width="65" />
          <el-table-column
            label="序号"
            type="index"
            width="55" />
          <el-table-column
            label="姓名"
            prop="name" />
          <el-table-column
            label="手机号"
            prop="phoneNumber" />
          <el-table-column label="邮箱">
            <template #default="{ row }">
              {{ row?.email || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            label="用户名"
            prop="userName" />
          <el-table-column
            label="操作"
            width="170">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  v-if="isChecked('Project.Single.ManagerManage.SetPermission')"
                  type="text"
                  size="small"
                  @click="openConfigPermissionDialog(row)">
                  配置目录树权限
                </el-button>
                <el-button
                  v-if="row.isLoginUser"
                  @click="exitProject(row)"
                  type="text"
                  size="small">
                  退出
                </el-button>
                <el-button
                  v-if="
                    isChecked('Project.ManagerManage.Delete') &&
                    !row.isLoginUser
                  "
                  @click="removeManager(row)"
                  size="small">
                  移除
                </el-button>
                <div v-if="isDisabledColumn(row)">--</div>
              </div>
            </template>
          </el-table-column>
          <!-- <template slot="empty">
            <div class="common-empty-box">
              <el-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">
                  <div class="empty-text">抱歉，没有找到相关内容</div>
                </template>
              </el-empty>
            </div>
          </template> -->
        </el-table>
      </div>
      <div class="common-pagination-box pagination-primary">
        <el-pagination
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange" />
      </div>
    </div>
    <UserRelationDialog
      :visible="isManagerDialogVisible"
      :userList="unBindUserList"
      :search="searchUnBindUserList"
      :submitRequest="createProjectUserRelation"
      :closeDialog="closeManagerDialog" />
    <PermissionConfigDialog
      :visible="isPermissionDialogVisible"
      :userInfo="userInfo"
      @closeDialog="closePermissionDialog" />
    <DragDialog
      title="项目移交"
      :width="360"
      :visible.sync="isTransferDialogVisible"
      :footerBtn="['cancel', 'submit']"
      :submit="submitTransfer"
      :cancel="closeTransferDialog">
      <div class="proj-transfer-box">
        <div class="user-input-box">
          <div class="label-box">移交给:</div>
          <div class="common-input-box">
            <el-input
              size="small"
              v-model="userFilterInput"
              placeholder="请输入用户名或手机号"
              clearable
              @clear="searchUser"
              @keyup.enter.native="searchUser">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="searchUser" />
            </el-input>
          </div>
        </div>
        <div class="user-list-box">
          <div
            v-for="(item, index) in userList"
            :key="index"
            class="user-item-box">
            <span>{{ item.surName }}</span>
            <div class="icon-box">
              <i
                class="el-icon-error icon"
                @click="removeUser(item)" />
            </div>
          </div>
        </div>
      </div>
    </DragDialog>
  </div>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import UserRelationDialog from '@/components/UserRelationDialog.vue'
import Spin from '@/components/Spin.vue'

import PermissionConfigDialog from './memberManage/PermissionConfigDialog.vue'
import { Store } from '@/utils/store'

import {
  getUserProjRelationListByProjService,
  getProjUnBindUserListByProjService,
  createProjUserRelationByProjService,
  exitProjCheckService,
  removeProjManagerCheckService,
  getNewProjManagerService,
  handoverProjService,
  delProjUserRelationByProjService,
  batchDelProjUserRelationByProjService
} from '@/service/interface'

export default {
  data() {
    return {
      userName: '',
      phone: '',
      currPage: 1,
      pageSize: 10,
      total: 0,
      managerList: [],
      selectManagers: [],

      isManagerDialogVisible: false,
      unBindUserList: [],

      isPermissionDialogVisible: false,
      userInfo: null,

      isTransferDialogVisible: false,
      projIdToHandover: '',
      userFilterInput: '',
      userList: [],
      loading: true,
      isEmpty: false,
      isExitProjFlag: false // 退出项目标识，项目管理员退出项目后需返回项目管理页面
    }
  },
  components: { DragDialog, UserRelationDialog, Spin, PermissionConfigDialog },
  mounted() {
    this.initProjRelationUserList()
  },
  methods: {
    initProjRelationUserList() {
      this.loading = true
      this.queryProjRelationUserList().then(managerList => {
        this.managerList = managerList
        this.loading = false
      })
    },
    searchManager() {
      this.queryProjRelationUserList().then(managerList => {
        this.managerList = managerList
      })
    },
    openConfigPermissionDialog(userInfo) {
      this.userInfo = userInfo
      this.isPermissionDialogVisible = true
    },
    closePermissionDialog() {
      this.isPermissionDialogVisible = false
      this.userInfo = null
    },
    resetFilter() {
      this.userName = ''
      this.phone = ''
    },
    updateUserList() {
      return new Promise(resolve => {
        this.queryProjRelationUserList().then(managerList => {
          this.managerList = managerList
          resolve()
        })
      })
    },
    selectChange(selectManagers) {
      this.selectManagers = selectManagers
    },
    exitProject(userInfo) {
      let projId = this.$route.params.projId
      exitProjCheckService(projId).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data && data.includes('可以直接退出')) {
            this.$confirm('确定退出项目？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                let userId = userInfo.userId
                this.removeProjManager(userId).then(() => {
                  this.$message.success('退出项目成功')
                  this.$router.push('../../../projectList')
                })
              })
              .catch(() => {
                this.$message.info('取消退出')
              })
          } else {
            this.projIdToHandover = projId
            this.isExitProjFlag = true
            this.openTransferDialog()
          }
        } else {
          let warningMsg = response.errMsg
          this.$confirm(warningMsg, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          })
        }
      })
    },
    openTransferDialog() {
      this.isTransferDialogVisible = true
    },
    searchUser() {
      if (!this.userFilterInput) {
        this.$message.warning('请输入用户名或手机号')
        return
      }
      let params = {
        input: this.userFilterInput
      }
      getNewProjManagerService(params).then(response => {
        if (response.isSuccess) {
          let surnameData = response.data
          this.handleSearchResult(surnameData)
        } else {
          this.$message.error('用户不存在，请重新输入！！！')
          this.userFilterInput = ''
        }
      })
    },
    removeUser(userInfo) {
      let findIndex = this.userList.findIndex(el => el.id === userInfo.id)
      this.userList.splice(findIndex, 1)
      this.userFilterInput = ''
    },
    handleSearchResult(data) {
      let find = this.userList.find(el => el.id === data.userId)
      if (!find) {
        this.userList = []
        let userInfo = {
          id: data.userId,
          surName: data.surName ? data.surName : data.userName
        }
        this.userList.push(userInfo)
      } else {
        this.$message.error('已选择该用户，请重新输入！！！')
        this.userFilterInput = ''
      }
    },
    submitTransfer() {
      if (!this.userList.length) {
        this.$message.warning('请先指定项目移交人员')
        return
      }
      let params = {
        projectId: this.projIdToHandover,
        userId: this.userList[0].id
      }
      handoverProjService(params).then(response => {
        if (response.isSuccess) {
          this.$message.success('移交成功!')
          if (this.isExitProjFlag) {
            this.$router.push('../../../projectList')
            this.closeTransferDialog()
          } else {
            this.updateUserList().then(() => {
              this.closeTransferDialog()
            })
          }
        } else {
          this.$message.error(response.errMsg)
          this.closeTransferDialog()
        }
      })
    },
    closeTransferDialog() {
      this.projIdToHandover = ''
      this.userFilterInput = ''
      this.userList = []
      this.isTransferDialogVisible = false

      this.isExitProjFlag = false
    },
    removeManager(userInfo) {
      let projectId = this.$route.params.projId
      let userId = userInfo.userId
      let params = { projectId, userId }
      removeProjManagerCheckService(params).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data && data.includes('可以直接移除')) {
            this.$confirm('确定移除用户？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                let userId = userInfo.userId
                this.removeProjManager(userId).then(() => {
                  this.$message.success('移除用户成功')
                })
              })
              .catch(() => {
                this.$message.info('取消移除')
              })
          } else {
            this.projIdToHandover = projectId
            this.openTransferDialog()
          }
        } else {
          let warningMsg = response.errMsg
          this.$confirm(warningMsg, '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          })
        }
      })
    },
    removeProjManager(userId) {
      return new Promise(resolve => {
        let projectId = this.$route.params.projId
        let params = { projectId, userId }
        delProjUserRelationByProjService(params).then(response => {
          if (response.isSuccess) {
            this.updateUserList().then(() => {
              resolve()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    batchRemoveManager() {
      if (!this.selectManagers.length) {
        this.$message.warning('请选择需要移除的用户')
        return
      }

      if (this.selectManagers.length === 1) {
        let projectId = this.$route.params.projId
        let userId = this.selectManagers[0].userId
        let params = { projectId, userId }
        removeProjManagerCheckService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data && data.includes('可以直接移除')) {
              this.$confirm('确定移除用户？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.removeProjManager(userId).then(() => {
                    this.$message.success('移除用户成功')
                  })
                })
                .catch(() => {
                  this.$message.info('取消移除')
                })
            } else {
              this.projIdToHandover = projectId
              this.openTransferDialog()
            }
          } else {
            let warningMsg = response.errMsg
            this.$confirm(warningMsg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning'
            })
          }
        })
        return
      }

      this.$confirm('确定移除用户？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let projectId = this.$route.params.projId
          let userIds = this.selectManagers.map(item => item.userId)
          let params = { projectId, userIds }
          batchDelProjUserRelationByProjService(params).then(response => {
            if (response.isSuccess) {
              this.updateUserList().then(() => {
                this.$message.success('用户移除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          this.$message.info('取消移除用户')
        })
    },
    pageChange(currPage) {
      this.currPage = currPage
      this.updateUserList()
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currPage = 1
      this.updateUserList()
    },
    openManagerDialog() {
      this.queryProjUnBindUserListList().then(unBindUserList => {
        this.unBindUserList = unBindUserList

        this.isManagerDialogVisible = true
      })
    },
    searchUnBindUserList(userName, phone) {
      this.queryProjUnBindUserListList(userName, phone).then(unBindUserList => {
        this.unBindUserList = unBindUserList
      })
    },
    createProjectUserRelation(userIds) {
      return new Promise(resolve => {
        let projectId = this.$route.params.projId
        let params = {
          projectId,
          userIds
        }
        createProjUserRelationByProjService(params).then(response => {
          if (response.isSuccess) {
            this.updateUserList().then(() => {
              this.$message.success('添加用户关系成功')
              resolve()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closeManagerDialog() {
      this.isManagerDialogVisible = false
    },
    queryProjRelationUserList() {
      return new Promise(resolve => {
        let projectId = this.$route.params.projId
        let params = {
          projectId,
          userName: this.userName,
          phone: this.phone,
          maxResultCount: this.pageSize,
          skipCount: (this.currPage - 1) * this.pageSize
        }
        getUserProjRelationListByProjService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let managerList = data.items
            this.total = data.totalCount
            resolve(managerList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryProjUnBindUserListList(userName, phone) {
      return new Promise(resolve => {
        let projectId = this.$route.params.projId
        let params = { projectId, userName, phone }
        getProjUnBindUserListByProjService(params).then(response => {
          if (response.isSuccess) {
            let unBindUserList = response.data
            resolve(unBindUserList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isDisabledColumn(userInfo) {
      let isDisabled = false
      if (!this.isChecked('Project.ManagerManage.Delete')) {
        isDisabled = true
      }

      if (isDisabled && userInfo.isLoginUser) {
        isDisabled = false
      }

      return isDisabled
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find?.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');
@import url('@/assets/css/pageStyle.less');
.proj-manager-box {
  flex-grow: 1;
  margin-bottom: 16px;

  .header-box {
    display: flex;
    justify-content: space-between;
    line-height: 30px;
    text-align: left;

    .title-box {
      display: flex;
      align-items: center;

      .symbol {
        width: 4px;
        height: 20px;
        background: var(--base-primary-bgColor);
      }

      .title {
        margin-left: 10px;
        color: var(--page-bread-text-color);
      }
    }
  }

  .operation-box {
    display: flex;
    justify-content: space-between;
    // margin: 10px 0px;

    .filter-box {
      display: flex;

      .filter-item-box {
        display: flex;
        align-items: center;
      }

      .common-button-box {
        .el-button {
          // margin-left: 15px;
          // margin-right: 0px;
        }
      }
    }
  }

  .manager-list-box {
    height: calc(100% - 112px);

    .common-table-box {
      height: calc(100% - 45px);

      .common-button-box {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button {
          margin-right: 0px;
        }
      }
    }

    .common-pagination-box {
      text-align: center;
    }
  }
}

.proj-transfer-box {
  color: var(--default-color);

  .user-input-box {
    display: flex;
    align-items: center;

    .common-input-box {
      flex-grow: 1;
      margin-left: 5px;
    }
  }

  .user-list-box {
    margin: 10px 0px 0px 55px;
    .user-item-box {
      display: inline-flex;
      align-items: center;
      border-radius: 20px;
      padding: 2px 10px;
      border: 1px solid var(--base-border-dark-color8);

      .icon-box {
        font-size: 14px;
        margin-left: 5px;
        color: var(--base-light-color11);
        cursor: pointer;
      }
    }
  }
}
</style>
